import states from '../../../resources/data/states.json';

class EditAddressController {

    constructor(scope, dialogService, address) {
        this._dialogService = dialogService;
        this._scope = scope;
        scope.states = states;

        scope.address = address;
        scope.save = form => this.save(form);
        scope.cancel = () => this.cancel();
    }

    save(form) {
        if (!form.$valid) {
            form.highlightAllErrors();
            return;
        }

        this._dialogService.hide(this._scope.address);
    }

    cancel() {
        this._dialogService.cancel();
    }
}

export default ['$scope', '$mdDialog', 'address', function (scope, dialogService, address) {
    return new EditAddressController(scope, dialogService, address);
}];



// WEBPACK FOOTER //
// ./src/modules/profile/controllers/EditAddressController.js